import { GET_PRODUCER_LIST } from '../../constants/reducerTypes';

const initialState = {
  producerList: [],
};

const producerListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCER_LIST:
      return {
        ...state,
        producerList: action.payload,
        error: action.payload.error || null,
      };
    default:
      return state;
  }
};

export default producerListReducer;
